export type Code<D = unknown> = {
  description?: string;
  data: D;
};
